export const Marquee = () => {
    const items = [
        "Website UMKM",
        "Toko Online",
        "Tour & Travel",
        "Showroom + Admin Panel",
        "Cafe & Resto",
        "Profil Personal",
        "SEO & Google Business",
        "Maintenance",
    ];
    const row = [...items, ...items];
    return (
        <section
            data-testid="marquee-section"
            className="border-y border-jws-border bg-jws-surface2 py-5 md:py-6 overflow-hidden"
        >
            <div className="flex animate-marquee whitespace-nowrap will-change-transform">
                {row.map((t, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-6 md:gap-8 px-6 md:px-8 font-display text-xl md:text-3xl tracking-tight"
                    >
                        <span>{t}</span>
                        <span className="h-1.5 w-1.5 md:h-2 md:w-2 rounded-full bg-jws-primary" />
                    </div>
                ))}
            </div>
        </section>
    );
};
